var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"card box-giga-glow-pink"},[_c('div',{staticClass:"card-body p-3 p-lg-5"},[_c('WizardNavigator',{attrs:{"steps":_vm.steps,"routeIndexes":_vm.routeIndexes}}),_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }